import { useTranslation } from "react-i18next";
import ConvertToString from "../../../components/Converter";
import PlusIcon from "../../../components/Icons/PlusIcon";
import Millimetre from "../../../components/Math/Units/Metric/Millimetre";
import RenderFor, { BM_TYP } from "../../../components/RenderFor";
import { RowBody } from "../../../components/RowValue/RowBody";
import ToolTip, { IconType } from "../../../components/ToolTip";

function RequiredGroutCover({ erforderlicheZementsteinueberdeckung, showModal }) {
  const { t } = useTranslation("translation");

  return (
    <RowBody
      titleValue={<p>{t("inner.verificationCapacity.requiredGroutCover")}</p>}
      indicesValue={
        <span>
          c<sub>req</sub>
        </span>
      }
      inputValue={
        <span className="input">{ConvertToString(erforderlicheZementsteinueberdeckung, 0)}</span>
      }
      unitValue={<Millimetre />}
      formulaValue={
        <>
          <RenderFor types={[BM_TYP.EUROCODE_7]}>
            <span className="input--formula" onClick={() => showModal(true)}>
              <PlusIcon />
            </span>
          </RenderFor>

          <ToolTip
            id={"c_req"}
            type={IconType.INFO}
            text={
              <>
                <RenderFor types={[BM_TYP.EUROCODE_7]}>
                  {t("aeussre.requiredGroutCover_info_EC7")}
                </RenderFor>
                <RenderFor types={[BM_TYP.GERMANY]}>
                  {t("inner.verificationCapacity.requiredGroutCover_info")}
                </RenderFor>
              </>
            }
          />
          <RenderFor types={[BM_TYP.GERMANY]}>
            <ToolTip
              id={"c_nom"}
              type={IconType.INFO}
              text={t("lvText.positionTestLoads.numberOfTestsInfo")}
            />
          </RenderFor>
        </>
      }
    />
  );
}

export default RequiredGroutCover;
